import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/productos-entregas";


const getProductosEntregas = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}`);
  return response.data;
};


const getDetalleProducto = async (productoId) => {
  const response = await axios.get(
    `${baseUrl}${endpoint}/${productoId}/detalle`
  );
  return response.data;
};

export {
  getProductosEntregas,
  getDetalleProducto
};